import React from "react";

const Footer = () => {
  return (
    <div className="footerWrapper">
      <div className="footer">
        <h3> &copy; Design and Developed by Aryan Bhandari</h3>
      </div>
    </div>
  );
};

export default Footer;
